define.alias("ember-cli-string-helpers/helpers/truncate", "preview-grid/helpers/truncate");